import { CLASS_NAME_PREFIX } from './GalleryElementHelper';

export function getCSS(elementId, uId, imageItemCount, thumbnailRowItemCount, itemsPerRow, compProps, imageHeight, imageCountTag) {
  const CSS = [];
  const lastSlideIdPlaceholder = `${CLASS_NAME_PREFIX}-slide${imageCountTag}-${uId}`;
  const firstSlideId = `${CLASS_NAME_PREFIX}-slide1-${uId}`;
  const firstThumbnailRowId = `${CLASS_NAME_PREFIX}-thumbnailRow0-${uId}`;
  for (let i = 1; i <= imageItemCount; i++) {
    const slideId = `${CLASS_NAME_PREFIX}-slide${i}-${uId}`;
    const nextSlideId = `${CLASS_NAME_PREFIX}-slide${(i % imageItemCount) + 1}-${uId}`;
    let prevSlideId = `${CLASS_NAME_PREFIX}-slide${(i - 1) % imageItemCount}-${uId}`;
    if (i === 1) {
      prevSlideId = `${CLASS_NAME_PREFIX}-slide${imageItemCount}-${uId}`;
    }
    const rowId = Math.floor((i - 1) / itemsPerRow);
    const thumbnailRowId = `${CLASS_NAME_PREFIX}-thumbnailRow${rowId}-${uId}`;
    const nextThumbnailRowId = `${CLASS_NAME_PREFIX}-slide${(((rowId + 1) * itemsPerRow)) % (thumbnailRowItemCount * itemsPerRow) + 1}-${uId}`;
    let prevThumbnailRowId = `${CLASS_NAME_PREFIX}-slide${(rowId * itemsPerRow)}-${uId}`;
    if (rowId === 0) {
      prevThumbnailRowId = `${CLASS_NAME_PREFIX}-slide${imageItemCount}-${uId}`;
    }

    const cssRules = `
    #${slideId}:checked ~ .${CLASS_NAME_PREFIX}-slider-content .${slideId} {
      opacity: 1;
    }
    #${slideId}:checked ~ .${CLASS_NAME_PREFIX}-slider-nav .${CLASS_NAME_PREFIX}-nav-button[for="${slideId}"] {
      background: #bbb;
    }
    #${slideId}:checked ~ .${CLASS_NAME_PREFIX}-slider-arrow-nav .${CLASS_NAME_PREFIX}-nav-arrow-wrapper-next[for="${nextSlideId}"] {
      visibility: visible;
    }
    #${slideId}:checked ~ .${CLASS_NAME_PREFIX}-slider-arrow-nav .${CLASS_NAME_PREFIX}-nav-arrow-wrapper-prev[for="${prevSlideId}"] {
      visibility: visible;
    }
    #${slideId}:checked ~ .${CLASS_NAME_PREFIX}-slider-content-thumbnails .${thumbnailRowId} {
      visibility: visible;
      opacity: 1;
    }
    #${slideId}:checked ~ .${CLASS_NAME_PREFIX}-slider-arrow-nav-thumbnails .${CLASS_NAME_PREFIX}-nav-arrow-wrapper-next-thumbnails[for="${nextThumbnailRowId}"] {
      visibility: visible;
    }
    #${slideId}:checked ~ .${CLASS_NAME_PREFIX}-slider-arrow-nav-thumbnails .${CLASS_NAME_PREFIX}-nav-arrow-wrapper-prev-thumbnails[for="${prevThumbnailRowId}"] {
       visibility: visible;
    }
    #${slideId}:checked ~ .${CLASS_NAME_PREFIX}-slider-content-thumbnails .${CLASS_NAME_PREFIX}-thumbnail-row .${CLASS_NAME_PREFIX}-thumbnail[for="${slideId}"] {
       outline: 1px solid #ffffff;
       border: 1px solid #000000;
       opacity: 1;
    }
    `;
    CSS.push(cssRules);
  }
  CSS.push(`
    #${elementId} .${CLASS_NAME_PREFIX}-nav-arrow-wrapper {
      height: ${imageHeight};
      padding-top: ${compProps.paddingTop}px;
      padding-bottom: ${compProps.paddingBottom}px;
    }
    #${elementId} .${CLASS_NAME_PREFIX}-nav-arrow-wrapper-next, .${CLASS_NAME_PREFIX}-nav-arrow-wrapper-next-thumbnails {
      right: ${compProps.paddingRight}px;
    }
    #${elementId} .${CLASS_NAME_PREFIX}-nav-arrow-wrapper-prev, .${CLASS_NAME_PREFIX}-nav-arrow-wrapper-prev-thumbnails {
      left: ${compProps.paddingLeft}px;
    }
  `);
  if (imageCountTag) {
    CSS.push(`
    #${lastSlideIdPlaceholder}:checked ~ .${CLASS_NAME_PREFIX}-slider-arrow-nav .${CLASS_NAME_PREFIX}-nav-arrow-wrapper-next[for="${firstSlideId}"] {
      visibility: visible;
      z-index: 10;
    }
    #${lastSlideIdPlaceholder}:checked ~ .${CLASS_NAME_PREFIX}-slider-arrow-nav-thumbnails .${CLASS_NAME_PREFIX}-nav-arrow-wrapper-next-thumbnails[for="${firstThumbnailRowId}"] {
      visibility: visible;
      z-index: 10;
    }
    #${firstSlideId}:checked ~ .${CLASS_NAME_PREFIX}-slider-arrow-nav .${CLASS_NAME_PREFIX}-nav-arrow-wrapper-prev[for="${lastSlideIdPlaceholder}"] {
      visibility: visible;
      z-index: 10;
    }
    #${firstSlideId}:checked ~ .${CLASS_NAME_PREFIX}-slider-arrow-nav-thumbnails .${CLASS_NAME_PREFIX}-nav-arrow-wrapper-prev-thumbnails[for="${firstThumbnailRowId}"] {
    }
    `);
  }
  return CSS.join('').replace(/\s{2,}/g, '');
}

